import React from "react";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { InputAdornment, Box } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const CustomTimePicker = ({
  label,
  name,
  onChange,
  value,
  required = false,
  error = false,
  helperText = "",
  size = "small",
  fontSize = "0.8rem",
  ...props
}) => {
  const [open, setOpen] = React.useState(false);

  const timeValue = React.useMemo(() => {
    if (!value || value === "") return null;
    try {
      const parsed = dayjs(value, ["HH:mm", "hh:mm A", "h:mm A"]);
      return parsed.isValid() ? parsed : null;
    } catch (e) {
      return null;
    }
  }, [value]);

  const handleTimeChange = (newValue) => {
    if (!newValue) {
      if (onChange) {
        onChange({
          target: {
            name: name,
            value: "",
          },
        });
      }
      return;
    }
    
    try {
      const formattedTime = newValue.isValid() ? newValue.format("HH:mm") : "";
      if (onChange) {
        onChange({
          target: {
            name: name,
            value: formattedTime,
          },
        });
      }
    } catch (e) {
      if (onChange) {
        onChange({
          target: {
            name: name,
            value: "",
          },
        });
      }
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileTimePicker
          label={label}
          value={timeValue}
          onChange={handleTimeChange}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          ampm={true}
          format="hh:mm A"
          {...props}
          slotProps={{
            textField: {
              fullWidth: true,
              size: size,
              required: required,
              error: error,
              helperText: helperText,
              onClick: () => setOpen(true),
              sx: { 
                cursor: 'pointer',
                '& .MuiInputBase-input': { 
                  cursor: 'pointer',
                  fontSize: fontSize,
                  padding: size === "small" ? "8.5px 14px" : "12px 14px",
                },
                '& .MuiInputLabel-root': {
                  fontSize: fontSize,
                },
                '& .MuiOutlinedInput-root': { 
                  borderRadius: '8px',
                  '& fieldset': {
                    borderColor: '#E2E8F0',
                  },
                  '&:hover fieldset': {
                    borderColor: '#94A3B8',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#2469F0',
                  },
                },
              },
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <AccessTimeIcon 
                      fontSize="small" 
                      sx={{ 
                        cursor: 'pointer',
                        fontSize: fontSize === "0.7rem" ? "16px" : "20px",
                      }} 
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpen(true);
                      }} 
                    />
                  </InputAdornment>
                ),
              },
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default CustomTimePicker;